import { Button, Icon, Modal, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { PageLayout } from '@hero/components/layouts';
import { VideoCard } from '@hero/molecules';

import * as S from './style';

export default function Page() {
  const { t } = useTranslation();

  const [activeVideo, setActiveVideo] = useState(null);

  const learningCenterVideos = t('learningCenterVideos', { returnObjects: true });

  if (!learningCenterVideos?.length) {
    return <Navigate to="/404" />;
  }

  return (
    <PageLayout
      header={{
        title: t('learningCenter'),
        components: {
          EndContent: () => (
            <>
              {t('sendUsAnEmail') && (
                <a href={`mailto:${t('mailTo')}`}>
                  <Button
                    variant="link"
                    color="secondary"
                    startIcon={<Icon name="email" size="md" />}
                  >
                    {t('sendUsAnEmail')}
                  </Button>
                </a>
              )}
              <VerticalDivider $margin="0 8px" $height="24px" />
            </>
          )
        }
      }}
    >
      <S.HelpPage>
        <S.HelpPageInfo>
          <Typography variant="body2" emphasis="weak">
            {t('helpText1')}
          </Typography>
          <Typography variant="body2" emphasis="weak">
            {t('helpText2')}
          </Typography>
        </S.HelpPageInfo>

        <S.HelpPageCards>
          {learningCenterVideos?.map(tutorial => (
            <S.HelpPageCard key={tutorial.key}>
              <VideoCard
                key={tutorial.key}
                url={tutorial.video}
                onClick={() => setActiveVideo(tutorial)}
                playable={false}
                ratio="33:22"
              />
              <Typography variant="body2" emphasis="weak">
                {t(tutorial.key)}
              </Typography>
            </S.HelpPageCard>
          ))}
        </S.HelpPageCards>

        <Modal
          isOpen={!!activeVideo}
          onRequestClose={() => setActiveVideo(null)}
          title={t(activeVideo?.key)}
          footerProps={{
            style: { display: 'none' }
          }}
          size="lg"
        >
          <VideoCard key="activeVideo" url={activeVideo?.video} />
        </Modal>
      </S.HelpPage>
    </PageLayout>
  );
}
